module.exports = __webpack_public_path__ + "img/ES3067.6826b793.png";